export const isString = (maybeString: unknown): maybeString is string =>
  typeof maybeString === typeof '';

export const isNumber = (maybeNumber: unknown): maybeNumber is number =>
  typeof maybeNumber === 'number' && !isNaN(maybeNumber);
